var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreferred = function SvgPreferred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.28 2.158 5.058 5.01A1.85 1.85 0 0 0 4 6.688v4.31C4 16.085 7.413 20.844 12 22c4.587-1.155 8-5.914 8-11.003v-4.31c0-.724-.418-1.384-1.058-1.677L12.72 2.158a1.72 1.72 0 0 0-1.44 0m-1.689 13.69L7.29 13.473a.934.934 0 0 1 0-1.293.866.866 0 0 1 1.253 0l1.68 1.724 5.227-5.392a.866.866 0 0 1 1.253 0 .934.934 0 0 1 0 1.293l-5.858 6.043a.866.866 0 0 1-1.253 0"
  })));
};
export default SvgPreferred;